import { createSelector, createStructuredSelector } from 'reselect';
import { indicatorSelector } from 'selectors/basic';

const helper = (fn) => createSelector(indicatorSelector, fn);
export const titleSelector = helper(({ longTitle }) => longTitle);
export const slugSelector = helper(({ slug }) => slug);
export const shortTitleSelector = helper(({ shortTitle }) => shortTitle);
const descriptionSelector = helper(({ snapshotNarrative }) =>
  snapshotNarrative);
const notesSelector = helper(({ notes }) => notes);
const sourcesSelector = helper(({ sources }) => sources);
const definitionsSelector = helper(({ definitions }) => definitions);
export const rangeBreaksSelector = helper(({ rangeBreaks }) => rangeBreaks);
export const dataFormatSelector = helper(({ dataFormat }) => dataFormat);
export const precisionSelector = helper(({ precision }) => precision);
export const relatedArticlesSelector = helper(({ relatedArticles }) =>
  relatedArticles);
export const dataViewSelector = helper(({ dataView }) => dataView);

export const infoSelector = createStructuredSelector({
  title: titleSelector,
  slug: slugSelector,
  description: descriptionSelector,
  notes: notesSelector,
  sources: sourcesSelector,
  definitions: definitionsSelector,
  shortTitle: shortTitleSelector,
  dataView: dataViewSelector,
});

export const dataSelector = createSelector(
  indicatorSelector,
  ({ data }) => data
);

export const geographySelector = createSelector(
  indicatorSelector,
  ({ geography }) => geography.byId
);

/**
 * A selector that determines if the router pathname begins with /embed/.
 * @param {string} pathname - The current path from React Router.
 * @returns {boolean} - True if the path begins with /embed/, false otherwise.
 */
export function isEmbeddedSelector({
  router: {
    location: {
      pathname = '',
    } = {},
  } = {},
}) {
  return 0 === pathname.indexOf('/embed/');
}

/**
 * A selector that determines if the router pathname begins with /image-export/.
 * @param {string} pathname - The current path from React Router.
 * @returns {boolean} - True if the path begins with /image-export/, false otherwise.
 */
export function isExportingSelector({
  router: {
    location: {
      pathname = '',
    } = {},
  } = {},
}) {
  return 0 === pathname.indexOf('/image-export/');
}

export default {
  infoSelector,
  slugSelector,
  dataSelector,
  titleSelector,
  geographySelector,
  dataFormatSelector,
  precisionSelector,
  rangeBreaksSelector,
  relatedArticlesSelector,
  isEmbeddedSelector,
  isExportingSelector,
};



// WEBPACK FOOTER //
// ./app/selectors/indicator/index.js